<template>
  <div class="approveok">
    <div class="approve-box text-c">
      <div class="approve-imgbox">
        <img class="approve" :src="img.default">
        <img class="sficon" :src="img.sficon">
      </div>
      
    </div>
    <div class="f-16 f-w text-c">xx认证成功</div>
    <div class="f-12 c-gray mt-25 text-c">恭喜您获得以下好礼！</div>
    <div class="mt-25">
      <div class="gift_box" style="border-bottom:0.5px solid rgba(0,0,0,.1);">
        <div class="f-12 gift_title">XXX积分 1000</div>
        <div class="getBtn">领取</div>
      </div>
      <div class="gift_box" style="border-bottom:0.5px solid rgba(0,0,0,.1);">
        <div class="f-12 gift_title">雷克萨斯镂空机械腕表-男士 1枚</div>
        <div class="getBtn">领取</div>
      </div>
      <div class="gift_box">
        <div class="f-12 gift_title">勋章：XXX1</div>
        <div class="getBtn">领取</div>
      </div>
    </div>
    <div class="privilege">
      <div class="f-18 f-w text-c mb-20">认证特权</div>
      <div class="privilege_info f-12">
        <div>
          <img :src="img.tqicon" class="tqicon">
          特殊认证标识，与众不同
        </div>
        <div class="mt-12">
         <img :src="img.tqicon" class="tqicon">
         发布的内容可获得官方推荐，增加人气
       </div>
       <div class="c-gray text-c mt-25">更多专属权益敬请期待！</div>
     </div>
   </div>
   <!-- <div class="iknowBtn" @click="goback()">我知道了</div> -->
 </div>
</template>
<script>
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  export default {
    data () {
      return {
        name:'',
        type:0,
        img:{
          default: require('../../../assets/img/lexus/default.png'),
          tqicon: require('../../../assets/img/subaru/approve/tqicon.png'),
          sficon: require('../../../assets/img/subaru/approve/sficon.png'),
        }
      }
    },

    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.tips=this.$route.query.tips
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: false})
      this.$appService.isTabbar({state: true})
      this.weburl=process.env.VUE_APP_URL
      if(this.$route.query.token){
        this.source = this.$route.query.source
        this.token = this.$route.query.token
        this.user_id = this.$route.query.userid
        this.$store.dispatch('param/setToken', this.$route.query.token)
      }
      var params={
        event_code: '认证成功',
        event_id: '',
        title: '',
        value: '',
        path: '/Subaru/My/Approveok.vue',
        user_id: this.user ? this.user.id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
    },
    methods: {
      goback(){
       if(this.source==5){
        wx.miniProgram.switchTab({url: '/pages/my/my'})
      }else{
        var params={
          url:this.weburl+'/subaru/my/index?source='+this.source ,
          isReturn: true 
        }
        this.$appService.openWebView(params)
      }
      
      
    }
    
  }
}
</script>

<style lang="scss">
  
  .approveok{
    background: #f1f1f1;
    background-color: #F1F1F1;
    .mt-25{
      margin-top: 25px;
    }
    .approve-box{
      margin-top: 40px;
      margin-bottom: 20px;
      display: flex;
      justify-content: center;
      .approve-imgbox{
        height: 72px;
        position:relative;
        .approve{
          width: 72px;
          height: 72px;
          position: relative;
          border-radius: 8px;
        }
        .sficon{
          width: 18px;
          height: 18px;
          position: absolute;
          bottom: -7px;
          right: -9px;
        }
      }
      
    }
    .gift_box{
      display: flex;
      margin: 0 15px;
      padding: 20px;
      align-items: center;
      background-color:#fff;
      .gift_title{
        flex: 1;
      }
      .getBtn{
        float: right;
        color: #fff;
        font-size:12px;
        padding:5px 15px;
        border-color: #1F2A74;
        background-color:#1F2A74;
        border-radius: 8px;
      }
    }
    .iknowBtn{
      color: #fff;
      font-size:12px;
      text-align: center;
      padding:12px 25px;
      margin: 25px 30%;
      border-color: #1F2A74;
      background-color:#1F2A74;
      border-radius: 8px;
    }
  }
  .privilege {
    padding: 26px;
    .mb-20{
      margin-bottom: 20px;
    }
    .mt-12{
      margin-top: 12px;
    }
    .mt-25{
      margin-top: 25px;
    }
    .privilege_info {
      padding: 26px 17px;
      background-color: #FFFFFF;
      .tqicon {
        width: 12px;
        height: 12px;
      }
    }
  }
</style>
